<template> 
  
  <div
    :class="`hero hero--${props.brandExperience}`"
    :style="`background: url(./hero/hero-${props.brandExperience}/bg.jpg);background-size: auto 100%;background-position: right bottom;`"
  >
    <img class="hero__img--drinkaware" src="../../public/misc/drinkaware--white.png">
    <div v-if="props.brandExperience == '1'" class="hero--hidden hidden" :style="`background: url(./hero/hero-2/bg.jpg);background-size: auto 100%;background-position: right bottom;`"></div>
    <div v-else class="hero--hidden hidden" :style="`background: url(./hero/hero-1/bg.jpg);background-size: auto 100%;background-position: right bottom;`"></div>
    <div class="hero__width">
      <div class="hero__button" :data-id="props.brandExperience">
        <div
          class="hero__button-bg"
          :style="{
            backgroundColor: dataModel[props.brandExperience].hero.btnBg,
            color: dataModel[props.brandExperience].hero.btnColor,
          }"
        >
          <div>SWITCH TO&nbsp;</div>
          <div class="hero__button-prod-text">{{dataModel[props.brandExperience].nextProd}}</div>
          <img
            class="hero__arrow"
            :src="dataModel[props.brandExperience].hero.btnArrow"
          />
        </div>
        <div class="hero__bottles">
          <img
            v-if="props.brandExperience === '1'"
            class="hero__img--button-bottle"
            src="../.././public/hero/hero-2/product.png"
          />
          <img
            v-else
            class="hero__img--button-bottle"
            src="../.././public/hero/hero-1/product.png"
          />
        </div>
      </div>
      <div class="hero__lockup">
        <div class="hero__col hero__col--l">
          <div class="hero__copy-lockup">
            <div class="hero__copy hero__h1" v-html="dataModel[props.brandExperience].hero.h1">
            </div>
            <div :class="`hero__copy hero__p hero__p--${props.brandExperience}`" v-html="dataModel[props.brandExperience].hero.p">
            </div>
          </div>
        </div>
        <div class="hero__col hero__col--r">
          <div
            v-if="props.brandExperience === '1'"
            class="hero__bottle-wrapper hero__bottle-wrapper--1"
          >
            <img class="hero__img--product" data-id="1" src="../.././public/hero/hero-1/product.png" />
            <img class="hero__img--product" data-id="2" src="../.././public/hero/hero-2/product.png" style="opacity: 0;" />
          </div>
          <div
            v-if="props.brandExperience === '2'"
            class="hero__bottle-wrapper hero__bottle-wrapper--1"
          >
            <img class="hero__img--product" data-id="2" src="../.././public/hero/hero-2/product.png" />
            <img class="hero__img--product" data-id="1" src="../.././public/hero/hero-1/product.png" style="opacity: 0;" />
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="hero-stripes">
    
    <div class="hero-stripe"></div>
    <div class="hero-stripe"></div>
    <div class="hero-stripe"></div>
    <div class="hero-stripes__tagline">PIMMS O'CLOCK</div>
  </div>
</template>
<script setup>
import gsap from 'gsap';
import dataModel from "../js/model.js";
const props = defineProps({
  brandExperience: {
    type: String,
    default: "1",
  }
});

$(document).ready(function() {

  var heroBg = function() {
    
    var dId = $('.hero__button').attr('data-id');

    if(window.innerWidth < 768) {
      if(dId == '1') {
        $('.hero').css({
          background: "url('./hero/hero-1/bg--mobile.png')",
          backgroundSize: 'cover'
        });
        $('.hero--hidden').css({
          background: "url('./hero/hero-2/bg--mobile.png')",
          backgroundSize: 'cover'
        })
      } else {
        $('.hero').css({
          background: "url('./hero/hero-2/bg--mobile.png')",
          backgroundSize: 'cover'
        })
        $('.hero--hidden').css({
          background: "url('./hero/hero-1/bg--mobile.png')",
          backgroundSize: 'cover'
        })
      }
    } else {
   
      
      if(dId == '1') {
        $('.hero').css({
          background: "url('./hero/hero-1/bg.jpg')",
        });
        $('.hero--hidden').css({
          background: "url('./hero/hero-2/bg.jpg')",
        })
      } else {
        $('.hero').css({
          background: "url('./hero/hero-2/bg.jpg')",
        });
        $('.hero--hidden').css({
          background: "url('./hero/hero-1/bg.jpg')",
        })
      }
      
    }
  }

  heroBg();

  props.brandExperience == '1' ? gsap.set('.hero__img--product[data-id="2"]', {y: -850}) : gsap.set('.hero__img--product[data-id="1"]', {y: 650})

  $(document).on('click', '.hero__button', function() {
    var dId = $(this).attr('data-id');
    $(this).css({pointerEvents: 'none'});
    if($('.hero--hidden').hasClass('hidden')) {
      $('.hero--hidden').removeClass('hidden');
      gsap.to('.hero--hidden', {
        duration: 1,
        opacity: 1
      })
    } else {
      $('.hero--hidden').addClass('hidden');
      gsap.to('.hero--hidden', {
        duration: 1,
        opacity: 0
      })
    }
    
    if(dId == 1) {

      $(this).attr('data-id', 2);
      $('.hero__button-prod-text').html(dataModel[2].nextProd);
      gsap.to('.hero__img--button-bottle', {
        duration: .5,
        y: -150,
        onComplete: () => {
          $('.hero__img--button-bottle').attr('src', './hero/hero-1/product.png');
          gsap.to('.hero__img--button-bottle', {
            duration: .5,
            y: 0,
          })
        }
      })
      gsap.to( ".hero__arrow", {
        duration: .2,
        x: 30,
        opacity: 0,
        onComplete: () => {
          $('.hero__arrow').attr('src', './misc/arrow--white.svg')
          gsap.set('.hero__arrow', {
            x: -30
          })
          gsap.to('.hero__arrow', {
            x: 0,
            opacity: 1
          })
        }
      });
      gsap.to( ".hero__button-bg", {
        backgroundColor: "#A51329",
        duration: .2,
        delay: .2
      });
      gsap.to( ".hero__button-bg > div", {
        color: "#FFFFFF",
        duration: .2,
        delay: .2
      });
      $('.hero__img--product[data-id="2"]').css({
        opacity: 1
      })
      gsap.to('.hero__img--product[data-id="1"]', {
        duration: 1,
        y: 650,
        ease: 'none'
      })
      gsap.to('.hero__img--product[data-id="2"]', {
        duration: 1,
        y: 0,
        delay: .5,
        ease: 'none',
        onComplete: function() {
          $('.hero__button').css({pointerEvents: 'all'})
        }
      })
      gsap.to('.hero__p', {
        duration: .25, opacity:0, y:50
      });
      gsap.to('.hero__h1', {
        duration: .25, delay: .1, opacity:0, y:50,
        onComplete: function() {
          $('.hero__h1').html(dataModel[2].hero.h1);
          $('.hero__p').html(dataModel[2].hero.p);
          if(window.innerWidth<768) {
            $('.hero__p').css({
              fontSize: '19px',
              lineHeight: '19px',
              paddingBottom: '81px'
            });
          } else {
            $('.hero__p').css({
              fontSize: '19px',
              lineHeight: '19px',
              paddingBottom: '93px'
            });
          }
          
          
          gsap.to('.hero__h1', {
            duration: .25, opacity:1, delay: .75, y:0
          });
          gsap.to('.hero__p', {
            duration: .25, opacity:1, y:0, delay: .85
          });
        }
      });
    } else {
      $(this).attr('data-id', 1);
      $('.hero__button-prod-text').html(dataModel[1].nextProd);
      gsap.to('.hero__img--button-bottle', {
        duration: .5,
        y: -150,
        onComplete: () => {
          $('.hero__img--button-bottle').attr('src', './hero/hero-2/product.png');
          gsap.to('.hero__img--button-bottle', {
            duration: .5,
            y: 0,
          })
        }
      })
      gsap.to( ".hero__arrow", {
        duration: .2,
        x: 30,
        opacity: 0,
        onComplete: () => {
          $('.hero__arrow').attr('src', './misc/arrow--red.svg')
          gsap.set('.hero__arrow', {
            x: -30
          })
          gsap.to('.hero__arrow', {
            x: 0,
            opacity: 1
          })
        }
      });
      gsap.to( ".hero__button-bg", {
        backgroundColor: "#ffffff",
        duration: .2,
        delay: .2
      });
      gsap.to( ".hero__button-bg > div", {
        color: "#A51329",
        duration: .2,
        delay: .2
      });
      $('.hero__img--product[data-id="1"]').css({
        opacity: 1
      })
      gsap.to('.hero__img--product[data-id="2"]', {
        duration: 1,
        y: -850,
        ease: 'none'
      })
      gsap.to('.hero__img--product[data-id="1"]', {
        duration: 1,
        y: 0,
        delay: .5,
        ease: 'none',
        onComplete: function() {
          $('.hero__button').css({pointerEvents: 'all'})
        }
      })
      gsap.to('.hero__p', {
        duration: .25, opacity:0, y:50
      });
      gsap.to('.hero__h1', {
        duration: .25, delay: .1, opacity:0, y:50,
        onComplete: function() {
          $('.hero__h1').html(dataModel[1].hero.h1);
          $('.hero__p').html(dataModel[1].hero.p);
          if(window.innerWidth<768) {
            $('.hero__p').css({
              fontSize: '19px',
              lineHeight: '19px',
              paddingBottom: '81px'
            });
          } else {
            $('.hero__p').css({
              fontSize: '24px',
              lineHeight: '24px',
              paddingBottom: '88px'
            });
          }
          
          gsap.to('.hero__h1', {
            duration: .25, opacity:1, delay: .75, y:0
          });
          gsap.to('.hero__p', {
            duration: .25, opacity:1, y:0, delay: .85
          });
        }
      });
    }
  })

  $( window ).resize(function() {
    
  });
  
})
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">

.hero {
  @include flexbox();
  @include align-items(center);
  @include justify-content(center);
  height: 650px;
  overflow: hidden;
  padding: 0px 50px;
  position: relative;
  width: 100%;
  @media screen and(min-width: 1783px) {
    background-size: cover !important;
  }
  @media screen and(max-width: 1600px) {
    background-position: center !important;
  }
  @media screen and(max-width: 1024px) {
    background-position: -300px center !important;
  }
  @media screen and(max-width: 1024px) {
    padding: 0px;
  }
  @media screen and(max-width: 768px) {
    background-position: center !important;
    height: 550px
  }
  @media screen and(max-width: 321px) {
    background-position: center !important;
    height: 450px
  }
}
.hero--hidden {
  height: 100%;
  opacity: 0;
  position: absolute;
  width: 100%;
}
.hero__width {
  @include flexbox();
  @include align-items(center);
  @include justify-content(center);
  height: 100%;
  max-width: 1280px;
  width: 100%;
}
.hero__lockup {
  @include flexbox();
  @include align-items(center);
  @include justify-content(center);
  height: 100%;
  max-width: 650px;
  width: 100%;
}
.hero__col {
  height: 100%;
  &--l {
    @include flex(1);
    @include flexbox();
    @include align-items(flex-end);
    @include justify-content(flex-end);
    position: relative;
    @media screen and(max-width: 768px) {
      @include flex(0, 1, auto);
    }
  }
  &--r {
    width: 200px;
    @media screen and(max-width: 768px) {
      padding-top: 100px;
      width: 125px;
    }
    @media screen and(max-width: 321px) {
      padding-top: 200px;
      width: 100px;
    }
  }
}
.hero__bottle-wrapper {
  height: 100%;
  position: relative;
  width: 100%;
}
.hero__img--product {
  display: block;
  position: absolute;
  top: 0px;
  width: 100%;
  &[data-id="1"] {
    top: 0%;
    @media screen and(max-width: 768px) {
      top: 0%;
    }
    @media screen and(max-width: 321px) {
      top: calc(-15% - 120px);
    }
  }
  &[data-id="2"] {
    top: 0%;
    @media screen and(max-width: 768px) {
      top: 0%;
    }
    @media screen and(max-width: 321px) {
      top: calc(-14.5% - 100px);
    }
  }
  
}
.hero__copy-lockup {
  position: relative;
}
.hero__h1 {
  color: #ffffff;
  font-size: 100px;
  line-height: 100px;
  text-shadow: 0px 0px 20px rgba(0,0,0,1);
  @media screen and(max-width: 768px) {
    font-size: 50px;
    line-height: 50px;
    width: 210px;
  }
  @media screen and(max-width: 321px) {
    font-size: 46px;
    line-height: 46px;
  }
}
.hero__p {
  color: #ffffff;

  &--1 {
    font-size: 24px;
    line-height: 24px;
    padding-bottom: 88px;
    @media screen and(max-width: 768px) {
      font-size: 19px;
      line-height: 19px;
      padding-bottom: 81px;
    } 
    @media screen and(max-width: 321px) {
    
      padding-bottom: 44px;
    }   
  }
  &--2 {
    font-size: 19px;
    line-height: 19px;
    padding-bottom: 93px;
    @media screen and(max-width: 768px) {
      padding-bottom: 81px;
    }    
  }
}
.hero__button {
  position: absolute;
  right: 50px;
  top: 50px;
  z-index: 1000;
  &:hover {
    cursor: pointer;
  }
  @media screen and(max-width: 1300px) {
    right: auto;
    left: 50px;
  }
  @media screen and(max-width: 768px) {
    background: #f0f0f0;
    left: 0px;
    padding: 10px;
    position: fixed;
    top: 0px;
    width: 100%;
  }
}
.hero__button-bg {
  @include flexbox();
  @include align-items(flex-start);
  @include justify-content(center);
  @include flex-direction(column);
  border-radius: 50px;
  font-size: 16px;
  line-height: 16px;
  height: 60px;
  padding-left: 30px;
  position: relative;
  text-align: left;
  width: 280px;
  &:hover {
    cursor: pointer;
  }
  @media screen and(max-width: 768px) {
    @include align-items(center);
    @include justify-content(flex-start);
    @include flex-direction(row);
    box-shadow: 0px 3px 5px rgba(0,0,0,0.15);
    overflow: hidden;
    width: 100%;
  }
}
.hero__bottles {
  @media screen and(max-width: 768px) {
    height: 60px;
    position: absolute;
    z-index: 1000;
    top: 10px;
    width: 100%;
    overflow: hidden;
  }
}
.hero__img--button-bottle {
  position: absolute;
  right: 30px;
  top: -45px;
  width: 30px;
  @media screen and(max-width: 768px) {
    right: 50px;
  }
}
.hero__arrow {
  position: absolute;
  right: 80px;
  width: 30px;
}
.hero__br {
  @media screen and(max-width: 768px) {
    display: block !important;
  }
}
.hero-stripes {
  width: 100%;
  padding-bottom: 20px;
  position: relative;
  @media screen and(max-width: 768px) {
    margin-top: 0px;
    padding-bottom: 50px;
  }
}
.hero-stripe {
  background: $color--red;
  height: 7px;
  margin-top: 7px;
  width: 100%;
  &:first-child {
    margin-top: 0px;
  }
}
.hero-stripes__tagline {
  @include flexbox();
  @include align-items(center);
  @include justify-content(center);
  height: 35px;
  background: #ffffff;
  color: $color--red;
  font-size: 26px;
  left: 100px;
  padding: 0px 10px;
  position: absolute;
  top: 0px;
  @media screen and(max-width: 768px) {
    left: 30px;
  }

}
.hero__img--drinkaware {
  position: absolute;
  bottom: 50px;
  display: block;
  right: 50px;
  width: 200px;
  @media screen and(max-width: 1300px) {
    bottom: auto;
    top: 50px;
  }
}
</style>